import PaginationRequest from './service/request/pagination'
import SortRequest from 'service/request/sort'

/** Запрос, в который можно дописать пагинацию. */
export type Paginated = { pagination?: PaginationRequest }
/** Запрос, в который можно дописать сортировку. */
export type Sorted = { sort?: SortRequest }

abstract class AbstractService {
  protected addPagination<T extends Paginated>(data: T, pagination: PaginationRequest): void {
    data.pagination = pagination
  }

  protected addSort<T extends Sorted>(data: T, sort: SortRequest): void {
    data.sort = sort
  }
}

export default AbstractService
